import { getElements } from '../Utility/Dom'

class FooterItemButton {
  private buttons: [] | NodeListOf<HTMLElement> = []

  constructor() {
    this.buttons = getElements('footer-item-button')
  }

  public init(): void {
    this.addEvents()
  }

  private addEvents(): void {
    this.buttons.forEach((button: HTMLElement): void => {
      button.addEventListener('click', (): void => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true'
        button.setAttribute('aria-expanded', (!isExpanded).toString())
      })
    })
  }
}

const footerItemButton = new FooterItemButton()
footerItemButton.init()
